import React from 'react';
import dayjs from '@ivario-arc/shared/src/utils/dayjs';
import { useTranslation } from 'react-i18next';
import { classNames } from '@utils/classNames';
import { Icon } from '@components/atoms/Icon';
import { IconType } from '@src/types/IconType';

interface StatusStepProps {
  activeIndex: number;
  label: string;
  date?: string;
  index: number;
  amount: number;
}

export const StatusStep: React.FC<StatusStepProps> = ({
  activeIndex,
  label,
  date,
  index,
  amount,
}) => {
  const { t: tDate } = useTranslation('date');
  const active = index <= activeIndex;
  const first = index === 0;
  const last = index === amount - 1;

  return (
    <div className="flex flex-row md:flex-col print:flex-col items-center md:text-center print:text-center relative py-2 md:py-0 print:py-0">
      {!first && (
        <div
          className={classNames(
            'absolute top-0 left-2 bottom-1/2 border-2',
            'md:top-3 md:left-0 md:right-1/2 md:bottom-full',
            'print:top-3 print:left-0 print:right-1/2 print:bottom-full',
            active ? 'border-ivarioBlue' : 'border-grey2',
          )}
        />
      )}
      {!last && (
        <div
          className={classNames(
            'absolute top-1/2 left-2 bottom-0 border-2',
            'md:top-3 md:left-1/2 md:right-0 md:bottom-full',
            'print:top-3 print:left-1/2 print:right-0 print:bottom-full',
            index < activeIndex ? 'border-ivarioBlue' : 'border-grey2',
          )}
        />
      )}
      {active ? (
        <div className="h-5 w-5 rounded-full mt-1 z-10 bg-grey3light relative">
          <Icon
            type={IconType.CheckmarkBubble}
            className="absolute h-6 w-6 -top-0.5 -left-0.5 z-10 text-grey3light bg-ivarioBlue"
            aria-hidden="true"
          />
        </div>
      ) : (
        <div
          className={`h-5 w-5 rounded-full mt-1 z-10 border-2 border-grey2 bg-grey3light`}
        />
      )}
      <div className="ml-2.5 md:ml-0 print:ml-0 flex flex-row md:flex-col print:flex-col items-center w-full justify-between">
        <p className={`${active ? 'font-bold' : 'font-light'} text-dark`}>
          {label}
        </p>
        {date && (
          <p className="text-sm text-grey1 font-light">
            {dayjs(date).format(tDate('format'))}
          </p>
        )}
      </div>
    </div>
  );
};
